export const externalList = [
  {
    value: 'AT',
    countryName: 'Österreich',
    label: 'Austria',
    icon: '🇦🇹',
    types: [
      {
        name: 'IdentityCard',
        id: 11,
      },
      {
        name: 'Passport',
        id: 12,
      },
    ],
  },
  {
    value: 'BE',
    countryName: 'België',
    label: 'Belgium',
    icon: '🇧🇪',
    types: [
      {
        name: 'IdentityCard',
        id: 15,
      },
      {
        name: 'Passport',
        id: 16,
      },
    ],
  },
  {
    value: 'BG',
    countryName: 'България',
    label: 'Bulgaria',
    icon: '🇧🇬',
    types: [
      {
        name: 'IdentityCard',
        id: 19,
      },
      {
        name: 'Passport',
        id: 20,
      },
    ],
  },
  {
    value: 'CY',
    countryName: 'Κύπρος',
    label: 'Cyprus',
    icon: '🇨🇾',
    types: [
      {
        name: 'IdentityCard',
        id: 47,
      },
      {
        name: 'Passport',
        id: 48,
      },
    ],
  },
  {
    value: 'CZ',
    countryName: 'Česko',
    label: 'Czechia',
    icon: '🇨🇿',
    types: [
      {
        name: 'Passport',
        id: 49,
      },
      {
        name: 'IdentityCard',
        id: 50,
      },
    ],
  },
  {
    value: 'DE',
    countryName: 'Deutschland',
    label: 'Germany',
    icon: '🇩🇪',
    types: [
      {
        name: 'IdentityCard',
        id: 53,
      },
      {
        name: 'Passport',
        id: 51,
      },
    ],
  },
  {
    value: 'DK',
    countryName: 'Danmark',
    label: 'Denmark',
    icon: '🇩🇰',
    types: [
      {
        name: 'Passport',
        id: 55,
      },
    ],
  },
  {
    value: 'EE',
    countryName: 'Eesti',
    label: 'Estonia',
    icon: '🇪🇪',
    types: [
      {
        name: 'IdentityCard',
        id: 63,
      },
      {
        name: 'Passport',
        id: 64,
      },
    ],
  },
  {
    value: 'ES',
    countryName: 'España',
    label: 'Spain',
    icon: '🇪🇸',
    types: [
      {
        name: 'IdentityCard',
        id: 62,
      },
      {
        name: 'Passport',
        id: 61,
      },
    ],
  },
  {
    value: 'FI',
    countryName: 'Suomi',
    label: 'Finland',
    icon: '🇫🇮',
    types: [
      {
        name: 'IdentityCard',
        id: 66,
      },
      {
        name: 'Passport',
        id: 67,
      },
    ],
  },
  {
    value: 'FR',
    countryName: 'France',
    label: 'France',
    icon: '🇫🇷',
    types: [
      {
        name: 'IdentityCard',
        id: 296,
      },
      {
        name: 'Passport',
        id: 68,
      },
    ],
  },
  {
    value: 'GB',
    countryName: 'United Kingdom',
    label: 'United Kingdom',
    icon: '🇬🇧',
    types: [
      {
        name: 'Passport',
        id: 71,
      },
    ],
  },
  {
    value: 'GR',
    countryName: 'Ελλάς',
    label: 'Greece',
    icon: '🇬🇷',
    types: [
      {
        name: 'IdentityCard',
        id: 215,
      },
      {
        name: 'Passport',
        id: 76,
      },
    ],
  },
  {
    value: 'HR',
    countryName: 'Hrvatska',
    label: 'Croatia',
    icon: '🇭🇷',
    types: [
      {
        name: 'IdentityCard',
        id: 193,
      },
      {
        name: 'Passport',
        id: 80,
      },
    ],
  },
  {
    value: 'HU',
    countryName: 'Magyarország',
    label: 'Hungary',
    icon: '🇭🇺',
    types: [
      {
        name: 'Passport',
        id: 82,
      },
      {
        name: 'IdentityCard',
        id: 83,
      },
    ],
  },
  {
    value: 'IE',
    countryName: 'Ireland',
    label: 'Ireland',
    icon: '🇮🇪',
    types: [
      {
        name: 'IdentityCard',
        id: 240,
      },
      {
        name: 'Passport',
        id: 85,
      },
    ],
  },
  {
    value: 'IS',
    countryName: 'Ísland',
    label: 'Iceland',
    icon: '🇮🇸',
    types: [
      {
        name: 'Passport',
        id: 88,
      },
    ],
  },
  {
    value: 'IT',
    countryName: 'Italia',
    label: 'Italy',
    icon: '🇮🇹',
    types: [
      {
        name: 'IdentityCard',
        id: 200,
      },
      {
        name: 'Passport',
        id: 90,
      },
    ],
  },
  {
    value: 'LI',
    countryName: 'Liechtenstein',
    label: 'Liechtenstein',
    icon: '🇱🇮',
    types: [
      {
        name: 'Passport',
        id: 105,
      },
      {
        name: 'IdentityCard',
        id: 231,
      },
    ],
  },
  {
    value: 'LT',
    countryName: 'Lietuva',
    label: 'Lithuania',
    icon: '🇱🇹',
    types: [
      {
        name: 'Passport',
        id: 107,
      },
      {
        name: 'IdentityCard',
        id: 108,
      },
    ],
  },
  {
    value: 'LU',
    countryName: 'Lëtezebuerg',
    label: 'Luxembourg',
    icon: '🇱🇺',
    types: [
      {
        name: 'Passport',
        id: 109,
      },
      {
        name: 'IdentityCard',
        id: 110,
      },
    ],
  },
  {
    value: 'LV',
    countryName: 'Latvija',
    label: 'Latvia',
    icon: '🇱🇻',
    types: [
      {
        name: 'Passport',
        id: 111,
      },
      {
        name: 'IdentityCard',
        id: 112,
      },
    ],
  },
  {
    value: 'MT',
    countryName: 'Malta',
    label: 'Malta',
    icon: '🇲🇹',
    types: [
      {
        name: 'Passport',
        id: 124,
      },
      {
        name: 'IdentityCard',
        id: 125,
      },
    ],
  },
  {
    value: 'NL',
    countryName: 'Nederland',
    label: 'The Netherlands',
    icon: '🇳🇱',
    types: [
      {
        name: 'IdentityCard',
        id: 136,
      },
      {
        name: 'Passport',
        id: 137,
      },
    ],
  },
  {
    value: 'NO',
    countryName: 'Norge',
    label: 'Norway',
    icon: '🇳🇴',
    types: [
      {
        name: 'IdentityCard',
        id: 283,
      },
      {
        name: 'Passport',
        id: 138,
      },
    ],
  },
  {
    value: 'PL',
    countryName: 'Polska',
    label: 'Poland',
    icon: '🇵🇱',
    types: [
      {
        name: 'IdentityCard',
        id: 146,
      },
      {
        name: 'Passport',
        id: 145,
      },
    ],
  },
  {
    value: 'PT',
    countryName: 'Portugal',
    label: 'Portugal',
    icon: '🇵🇹',
    types: [
      {
        name: 'Passport',
        id: 147,
      },
      {
        name: 'IdentityCard',
        id: 148,
      },
    ],
  },
  {
    value: 'RO',
    countryName: 'România',
    label: 'Romania',
    icon: '🇷🇴',
    types: [
      {
        name: 'Passport',
        id: 154,
      },
      {
        name: 'IdentityCard',
        id: 301,
      },
    ],
  },
  {
    value: 'SE',
    countryName: 'Sverige',
    label: 'Sweden',
    icon: '🇸🇪',
    types: [
      {
        name: 'IdentityCard',
        id: 168,
      },
      {
        name: 'Passport',
        id: 169,
      },
    ],
  },
  {
    value: 'SI',
    countryName: 'Slovenija',
    label: 'Slovenia',
    icon: '🇸🇮',
    types: [
      {
        name: 'Passport',
        id: 166,
      },
      {
        name: 'IdentityCard',
        id: 167,
      },
    ],
  },
  {
    value: 'SK',
    countryName: 'Slovensko',
    label: 'Slovakia',
    icon: '🇸🇰',
    types: [
      {
        name: 'Passport',
        id: 163,
      },
      {
        name: 'IdentityCard',
        id: 165,
      },
    ],
  },
]
